export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4744.e17aebb0.jpg";